import {
  getEcommerceByIds,
  getItemListNameFromBreadcrumb,
  selectItemEvent,
  viewItemListEvent,
} from "@src/analytics";

export const pushSelectItemEventFromId = (propertyId: string) => {
  getEcommerceByIds([propertyId]).then((ecommerce) => {
    getItemListNameFromBreadcrumb().then((item_list_name) => {
      selectItemEvent({
        ...ecommerce,
        item_list_name,
      });
    });
  });
};

export const getPropertyIdsFromHtml = (html: string): string[] => {
  const dom = new DOMParser().parseFromString(html, "text/html");
  const propertyElements = dom.querySelectorAll(
    ".container-search-cards-community"
  ) as NodeListOf<HTMLElement>;
  const propertyIds: string[] = [];
  propertyElements.forEach((ele) => {
    const propertyId = ele.getAttribute("data-property-id");
    if (propertyId) {
      propertyIds.push(propertyId);
    }
  });
  return propertyIds;
};

export const pushViewItemListEventFromHtml = (html: string) => {
  const propertyIds = getPropertyIdsFromHtml(html);
  getEcommerceByIds(propertyIds).then((ecommerce) => {
    getItemListNameFromBreadcrumb().then((item_list_name) => {
      viewItemListEvent({
        ...ecommerce,
        item_list_name,
      });
    });
  });
};
